<template>
    <div class="d-flex align-center pl-2" style="width: 100%; position: relative" >

        <v-btn
                icon
                class="mr-2"
                color="primary"
                v-if="backPages.length"
                @click.stop="goBack()"
        >
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.setup">
            <app-teams-toolbar v-if="$store.state.ref.app.curPage === 'teams'" class="app-bar-content"></app-teams-toolbar>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.setup">
            <app-devices-toolbar v-if="$store.state.ref.app.curPage === 'devices'" class="app-bar-content">
                <app-nav-bar-tabs v-model="$store.state.ref.devices.tabIndex" :tabs="['Active', 'Disabled', 'Pending Devices']"/>
            </app-devices-toolbar>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.setup">
            <app-employees-toolbar v-if="$store.state.ref.app.curPage === 'employees'" class="app-bar-content">
                <app-nav-bar-tabs v-model="$store.state.ref.employees.tabIndex" :tabs="['Active', 'Disabled']"/>
            </app-employees-toolbar>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.users">
            <app-users-toolbar v-if="$store.state.ref.app.curPage === 'users'" class="app-bar-content">
                <app-nav-bar-tabs v-model="$store.state.ref.users.tabIndex" :tabs="['Active', 'Disabled']"/>
            </app-users-toolbar>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.classification">
            <app-classification-toolbar v-if="$store.state.ref.app.curPage === 'classification'" class="app-bar-content">
                <app-nav-bar-tabs
                  v-model="$store.state.ref.classification.tabIndex"
                  :tabs="
                  store.getters.getSiteConfig ?
                  ['All', 'Labeled',  'AI Classified', 'Unlabeled', 'Manual Time']
                  : ['All', 'Labeled', 'Unlabeled', 'Manual Time']
                  "
                />
            </app-classification-toolbar>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.statistics">
            <app-dashboard-toolbar ref="dashboardToolbar" v-if="$store.state.ref.app.curPage === 'dashboard'" class="app-bar-content" @exportDashboardData="$emit('exportDashboardData')" @exportDashboardDataDetail="$emit('exportDashboardDataDetail')">
                <app-nav-bar-tabs v-model="$store.state.ref.dashboard.tabIndex" :tabs="['Today', 'Teams', 'Employees', 'Apps']"/>
            </app-dashboard-toolbar>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.statistics">
            <app-employee-stats-toolbar v-if="$store.state.ref.app.curPage === 'employeeStats'" class="app-bar-content"/>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.approvals">
            <app-approvals-toolbar v-if="$store.state.ref.app.curPage === 'approvals'" class="app-bar-content">
              <app-nav-bar-tabs v-model="$store.state.ref.approvals.tabIndex"  :tabs="['Pending', 'Approved', 'Declined']"/>
            </app-approvals-toolbar>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.leave">
            <app-leave-toolbar v-if="$store.state.ref.app.curPage === 'leave'" class="app-bar-content">
                <app-nav-bar-tabs v-model="$store.state.ref.leave.tabIndex" :tabs="['Calendar', 'Table']"/>
            </app-leave-toolbar>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.statistics">
            <app-team-stats-toolbar v-if="$store.state.ref.app.curPage === 'teamStats'" class="app-bar-content"/>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.statistics">
            <app-app-stats-toolbar v-if="$store.state.ref.app.curPage === 'appStats'" class="app-bar-content"/>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true" v-if="access.billing">
            <app-admin-toolbar v-if="$store.state.ref.app.curPage === 'admin'" class="app-bar-content">
                <app-nav-bar-tabs v-model="$store.state.ref.admin.tabIndex" :tabs="['Company Information', 'Usage Reports']"/>
<!--                , 'Invoices'-->
            </app-admin-toolbar>
        </v-scroll-x-reverse-transition>

        <v-scroll-x-reverse-transition :hide-on-leave="true">
            <app-partner-toolbar v-if="$store.state.ref.app.curPage === 'partner'" class="app-bar-content">
                <app-nav-bar-tabs v-model="$store.state.ref.partner.tabIndex" :tabs="user.masterAdmin ? ['Admin', 'Sites', 'Payments', 'Partners', 'Manage', 'Site Management'] : ['Admin', 'Sites', 'Payments']"/>
            </app-partner-toolbar>
        </v-scroll-x-reverse-transition>
    </div>
</template>

<script>
// import AppNavBarTabs from "@/components/General/AppNavBarBody/AppNavBarTabs";
import AppNavBarTabs from "@/components/Shared/AppNavBarBody/AppNavBarTabs";
import AppTeamsToolbar from "@/components/Teams/AppTeamsToolbar";
import AppDevicesToolbar from "@/components/Devices/AppDevicesToolbar";
import AppEmployeesToolbar from "@/components/Employees/AppEmployeesToolbar";
import AppUsersToolbar from "@/components/Users/AppUsersToolbar";
import AppClassificationToolbar from "@/components/Classification/AppClassificationToolbar";
import AppDashboardToolbar from "@/components/Dashboard/AppDashboardToolbar";
import AppEmployeeStatsToolbar from "@/components/EmployeeStats/AppEmployeeStatsToolbar";
import AppTeamStatsToolbar from "@/components/TeamStats/AppTeamStatsToolbar";
import AppAppStatsToolbar from "@/components/AppStats/AppAppStatsToolbar";
import {mapActions, mapGetters} from "vuex";
import AppAdminToolbar from "@/components/Admin/AppAdminToolbar";
import AppPartnerToolbar from "@/components/Partner/AppPartnerToolbar";
import AppApprovalsToolbar from "@/components/Approvals/AppApprovalsToolbar.vue";
import AppLeaveToolbar from "@/components/Leave/AppLeaveToolbar.vue";
import store from "../../../core/store";
export default {
    components: {
        AppLeaveToolbar,
        AppApprovalsToolbar,
        AppPartnerToolbar,
        AppAdminToolbar,
        AppTeamStatsToolbar,
        AppEmployeeStatsToolbar,
        AppDashboardToolbar,
        AppClassificationToolbar,
        AppUsersToolbar, AppEmployeesToolbar, AppDevicesToolbar, AppTeamsToolbar, AppNavBarTabs, AppAppStatsToolbar},
    // components: {AppNavBarTabs},
    props: {
        parent: Object
    },
    data() {
        return {
            vm: this,
            con: console
        }
    },
    methods: {
        ...mapActions(['gotoPage', 'goBack'])
    },
    computed: {
      store() {
        return store
      },

        ...mapGetters(['backPages', 'access', "user"]),

        refVars: {
            get() {
                return this.$store.state.refVars
            },
            set(val) {
                Object.assign(this.$store.state.refVars, val)
            }
        },

        curPage: {
            get() {
                return this.$store.state.ref.app.curPage
            },
            set(val) {
                this.gotoPage(val)
            }
        }
    }
}
</script>

<style scoped>
    .app-bar-content{
        width: 100%;
        height: 50px;
    }
</style>